









import Vue from 'vue';
import ArrowIcon from '../../icons/ArrowIcon.vue';

export default Vue.extend({
  name: `MobileMenuBack`,
  components: {
    ArrowIcon,
  },
  computed: {
    label(): string {
      return this.$t(`header:backText`);
    },
  },
});
